import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Interface for the chat
interface IChatState {
	showWatchVideos: boolean
}

// Initial state
const initialState: IChatState = {
	showWatchVideos: false
}

// Slice definition
export const chatSlice = createSlice({
	name: 'chat',
	initialState,
	reducers: {
		setShowWatchVideos: (state, action: PayloadAction<boolean>) => {
			state.showWatchVideos = action.payload
		}
	}
})

// Export actions
export const { setShowWatchVideos } = chatSlice.actions

// Export selectors
export const showWatchVideos = (state: RootState) => state.chat.showWatchVideos

// Export the reducer
export default chatSlice.reducer
